import { useCurrentURL } from '@hooks/useCurrentURL';
import { URLParameters } from '../../../views/Authentication/constants';
import { NonCrawlableLink } from '../../Clickables/NonCrawlableLink/NonCrawlableLink';
import { Text } from '../../Text/Text';

export const AnglerSignUpCTA = () => {
  const { addParameters } = useCurrentURL();
  const loginLink = addParameters({ [URLParameters.Flow]: 'login' });

  return (
    <div className="w-full grow py-4 pl-3">
      <div className="text-midnight mb-2 text-sm font-semibold tracking-wider uppercase">
        Anglers
      </div>
      <Text variant="sm" className="mb-2">
        Log in to search for anglers
      </Text>
      <NonCrawlableLink
        routerPushTo={loginLink}
        variant="textPrimaryDarkBg"
        className="pt-2"
        ariaLabel="log in to your Fishbrain account"
      >
        <Text variant="sm" className="mb-0 font-semibold">
          Log in
        </Text>
      </NonCrawlableLink>
    </div>
  );
};
